type Placement =
  | "top-left"
  | "top-center"
  | "top-right"
  | "left"
  | "center"
  | "right"
  | "bottom-left"
  | "bottom-center"
  | "bottom-right";

const POSITIONS: Record<Placement, string> = {
  "top-left": "25% 30%",
  "top-center": "50% 30%",
  "top-right": "75% 30%",
  "left": "25% 50%",
  "center": "50% 50%",
  "right": "75% 50%",
  "bottom-left": "30% 70%",
  "bottom-center": "50% 65%",
  "bottom-right": "70% 70%",
};

type Props = {
  placement?: Placement;
  opacity?: number;
};

const SectionGlow = ({ placement = "center", opacity = 0.05 }: Props) => (
  <div
    className="absolute inset-0 pointer-events-none z-[-1]"
    style={{
      background: `radial-gradient(ellipse 60% 50% at ${POSITIONS[placement]}, hsl(152 30% 40% / ${opacity}), transparent 70%)`,
    }}
  />
);

export default SectionGlow;
